<template>
  <div />
</template>

<style lang="scss">
@use "@sass/base/variables";

.search-filters--tm4728 {
  height: 56px!important;

  .search-filters__tab, .option__button, .option__button--selected {
    border: none !important;
  }
}
@media #{variables.$for-mobile} {
  .v-search-map-component--tm4728 {
    top: 112px !important;
    height: calc(100vh - 112px) !important;
    height: calc(100svh - 112px) !important;
  }
}

.v-search-rooms-component--tm4728 {
  margin-top: 0!important;

  @media #{variables.$for-mobile} {
    margin-top: 64px!important;
  }
}
</style>
